@if (!item) {
  <div
    class="empty-state"
    >
    <img class="empty-state-image" src="assets/placeholders/empty-sheets.png" alt="image for empty sheets view"/>
  </div>
}

@if (item) {
  @switch (item | stitchType) {
    @case (StitchType.SHEET) {
      <app-sheet-form
        id="sheet-form"
        [sheet]="asSheet(item)"
        (close)="handleFormClose($event)"
        />
    }
    @case (StitchType.SHEET_FOLDER) {
      <app-sheet-folder-form
        id="sheet-folder-form"
        [sheetFolder]="asSheetFolder(item)"
        (close)="handleFormClose($event)"
        />
    }
  }
}
